var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoiceMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.156 7.17809C18.156 6.09521 17.7258 5.05669 16.9601 4.29098C16.1944 3.52526 15.1559 3.09509 14.073 3.09509C12.9901 3.09509 11.9516 3.52526 11.1859 4.29098C10.4202 5.05669 9.98999 6.09521 9.98999 7.17809V14.7621C9.98999 15.845 10.4202 16.8835 11.1859 17.6492C11.9516 18.4149 12.9901 18.8451 14.073 18.8451C15.1559 18.8451 16.1944 18.4149 16.9601 17.6492C17.7258 16.8835 18.156 15.845 18.156 14.7621V7.17809Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.323 14.1781C5.323 16.4987 6.24487 18.7243 7.88581 20.3653C9.52676 22.0062 11.7524 22.9281 14.073 22.9281M14.073 22.9281C15.2221 22.9281 16.3599 22.7018 17.4215 22.262C18.4831 21.8223 19.4477 21.1778 20.2602 20.3653C21.0727 19.5528 21.7172 18.5882 22.1569 17.5266C22.5967 16.465 22.823 15.3272 22.823 14.1781M14.073 22.9281V26.4281",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceMessage);
export default __webpack_public_path__ + "static/media/voiceMessage.62afd9e9b8f52c7d5ae132bcf1ad7c54.svg";
export { ForwardRef as ReactComponent };